export default __webpack_public_path__ + "static/media/banner.b9f74cfe.png";